export const RECENT_COMPANIES_STORAGE_KEY = "admin_quick_nav_recent_companies";
export const MAX_RECENT_COMPANIES = 10;
export const BACKSPACE_KEY = "Backspace";
